
import React from "react";
import { motion } from "framer-motion";
import EnrollmentTrendsChart from "@/components/dashboard/EnrollmentTrendsChart";
import ProgramDistributionChart from "@/components/dashboard/ProgramDistributionChart";

interface ChartsSectionProps {
  enrollmentTrendsData: Array<{ name: string; enrollments: number }>;
  programDistributionData: Array<{ name: string; value: number }>;
  loading: boolean;
}

const ChartsSection = ({ 
  enrollmentTrendsData, 
  programDistributionData, 
  loading 
}: ChartsSectionProps) => {
  return (
    <motion.div 
      className="lg:col-span-2 space-y-6"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.3, duration: 0.5 }}
    >
      {/* Enrollment Trends */}
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
        <h3 className="text-xl font-semibold mb-4">Student Enrollments</h3>
        <EnrollmentTrendsChart 
          data={enrollmentTrendsData} 
          loading={loading} 
        />
      </div>
      
      {/* Insights Section */}
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-6">
        <h3 className="text-xl font-semibold mb-4">Insights</h3>
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <h4 className="text-md font-medium mb-2">Top Programs</h4>
            <ProgramDistributionChart 
              data={programDistributionData} 
              loading={loading} 
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ChartsSection;
